import { render } from "./AddPhotoPage.vue?vue&type=template&id=00523402&scoped=true"
import script from "./AddPhotoPage.vue?vue&type=script&lang=js"
export * from "./AddPhotoPage.vue?vue&type=script&lang=js"

import "./AddPhotoPage.vue?vue&type=style&index=0&id=00523402&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00523402"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QUploader from 'quasar/src/components/uploader/QUploader.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QStepper,QStep,QToggle,QTooltip,QIcon,QBtn,QStepperNavigation,QUploader});qInstall(script, 'directives', {Ripple});
